import { DashboardZones } from "@/entities/api/users/users"


const moduleConvert = (module: DashboardZones) => {
	switch (module) {
		case 'orders':
			return 'Pedidos'
		case 'inventary':
			return 'Inventario'
		case 'users':
			return 'Usuarios'
		case 'customers':
			return 'Clientes'
		case 'contact':
			return 'Asistencia al cliente'
		case 'categories':
			return 'Categorias'
		case 'coupons':
			return 'Cupones'
				case 'sales':
			return 'Ventas'
		default:
			return 'Modulo sin definir'
	}
}

export default moduleConvert
